import { privacyPolicy } from '../../analytics/privacy.js'

/**
 * 隐私指示器组件
 * 右下角悬浮小图标，点击可查看数据使用说明
 */
export class PrivacyIndicator {
  constructor() {
    this.element = null
    this.modal = null
    this.isOpen = false
  }

  render(container) {
    this.element = document.createElement('button')
    this.element.className = 'privacy-indicator'
    this.element.setAttribute('aria-label', '隐私说明')
    this.element.setAttribute('title', '隐私说明')
    this.element.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    `

    this.element.addEventListener('click', () => this._toggleModal())
    container.appendChild(this.element)
  }

  _toggleModal() {
    if (this.isOpen) {
      this._closeModal()
    } else {
      this._openModal()
    }
  }

  _openModal() {
    if (this.modal) {
      this._closeModal()
      return
    }

    const scope = privacyPolicy.getCollectionScope()

    this.modal = document.createElement('div')
    this.modal.className = 'privacy-modal'
    this.modal.innerHTML = `
      <div class="privacy-modal-backdrop"></div>
      <div class="privacy-modal-content">
        <div class="privacy-modal-header">
          <h4>数据使用说明</h4>
          <button class="privacy-modal-close" aria-label="关闭">×</button>
        </div>
        <div class="privacy-modal-body">
          <p class="privacy-intro">我们使用隐私友好的分析工具来改进网站体验。</p>

          <div class="privacy-section">
            <h5>我们收集的数据</h5>
            <ul>
              ${scope.collected.map(item => `<li>${item}</li>`).join('')}
            </ul>
          </div>

          <div class="privacy-section">
            <h5>我们不会收集</h5>
            <ul class="privacy-negative">
              ${scope.notCollected.map(item => `<li>${item}</li>`).join('')}
            </ul>
          </div>

          <div class="privacy-section">
            <h5>用途说明</h5>
            <p>${scope.purpose}</p>
          </div>

          <div class="privacy-section">
            <h5>第三方服务</h5>
            <p>${scope.thirdParty}</p>
          </div>
        </div>
      </div>
    `

    const backdrop = this.modal.querySelector('.privacy-modal-backdrop')
    const closeBtn = this.modal.querySelector('.privacy-modal-close')

    backdrop.addEventListener('click', () => this._closeModal())
    closeBtn.addEventListener('click', () => this._closeModal())

    this._handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this._closeModal()
      }
    }
    document.addEventListener('keydown', this._handleKeyDown)

    document.body.appendChild(this.modal)
    this.isOpen = true

    requestAnimationFrame(() => {
      this.modal.classList.add('visible')
    })
  }

  _closeModal() {
    if (!this.modal) return

    this.modal.classList.remove('visible')

    setTimeout(() => {
      if (this.modal) {
        this.modal.remove()
        this.modal = null
      }
    }, 200)

    if (this._handleKeyDown) {
      document.removeEventListener('keydown', this._handleKeyDown)
      this._handleKeyDown = null
    }

    this.isOpen = false
  }
}
